var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconClose = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.1134 12.1429L22.1429 19.1727L19.1721 22.1429L12.1426 15.1138L5.11376 22.1429L2.14294 19.1727L9.17175 12.1429L2.14294 5.11301L5.11376 2.14285L12.1426 9.17193L19.1721 2.14285L22.1429 5.11301L15.1134 12.1429Z",
  fill: "#000000"
})));
export default SvgIconClose;